import axios from "axios";

export default class Mobility {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;

  }

  async getLists(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/mobile-stiba/files`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async UploadStiba(queries) {
    try {
      const response = await axios({
        method: "post",
        headers: {
          "Content-Type": 'multipart/form-data',
        },
        url: `${this.API_LINK}/mobile-stiba/files/upload`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }



  async dowloadFile(id) {
    try {
      // const response = BENEFITS.data.filter(benefit => benefit.id == id);
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/mobile-stiba/files/${id}/download`
      });
      // console.log(response);
      // return response[0];
      return response.data;
    } catch (error) {
      throw error;
    }
  }


  async downloadS3Report(id) {
    try {
      // const response = BENEFITS.data.filter(benefit => benefit.id == id);
      const response = await axios({
        method: "get",   
        url: `${this.API_LINK}/mobile-stiba/files/${id}/download/s3`
      });
      // console.log(response);
      // return response[0];
      return response.data;
    } catch (error) {
      throw error;
    }
  }


  async validateDates(queries) {
    try {
      // const response = BENEFITS.data.filter(benefit => benefit.id == id);
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/mobile-stiba/validate`,
        data: queries
      });
      // console.log(response);
      // return response[0];
      return response.data;
    } catch (error) {
      throw error;
    }
  }



}
